import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Scroll {
    constructor(element) {
        if (!element) return;
        this.element = element;
        this.lenis = null;

        this.init();
    }

    init() {
        this.lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smoothWheel: true,
            touchMultiplier: 0.2,
            infinite: false,
        });

        this.lenis.on('scroll', ScrollTrigger.update);

        this.render = this.render.bind(this);
        requestAnimationFrame(this.render);

        this.setupEvents();
        this.initParallax();
    }

    initParallax() {
        const ballon = document.querySelector('.js-ballon');
        const section = document.querySelector('.page-section-1-ptb');

        if (ballon && section) {
            gsap.fromTo(ballon,
                {
                    y: 700,
                    scale: 0.8,
                    opacity: 0.5
                },
                {
                    y: -50,
                    scale: 1.1,
                    opacity: 1,
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: 1.5,
                    }
                }
            );
        }
    }

    render(time) {
        this.lenis.raf(time);
        requestAnimationFrame(this.render);
    }

    setupEvents() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                const target = document.querySelector(anchor.getAttribute('href'));
                if (target) {
                    this.lenis.scrollTo(target);
                }
            });
        });
    }

    stop() {
        this.lenis.stop();
    }

    start() {
        this.lenis.start();
    }

    destroy() {
        this.lenis.destroy();
        ScrollTrigger.getAll().forEach(t => t.kill());
    }
}
